import React from "react";
import { X } from "lucide-react";
import { Input } from "@/components/ui/input";

export const EMPTY_ORDER_FILTERS = { q: "", payment: "", partner: "", from: "", to: "" };

export const applyOrderFilters = (orders, f) => {
  const q = f.q.trim().toLowerCase();
  const from = f.from ? new Date(f.from + "T00:00:00") : null;
  const to = f.to ? new Date(f.to + "T23:59:59.999") : null;
  return orders.filter((o) => {
    if (q && ![o.order_number, o.customer_name, o.email, o.tracking_number, o.affiliate?.brand_name].some((v) => String(v || "").toLowerCase().includes(q))) return false;
    if (f.payment && o.payment_status !== f.payment) return false;
    if (f.partner === "__direct" && o.affiliate?.slug) return false;
    if (f.partner && f.partner !== "__direct" && o.affiliate?.slug !== f.partner) return false;
    const when = o.created_at ? new Date(o.created_at) : null;
    if (from && (!when || when < from)) return false;
    if (to && (!when || when > to)) return false;
    return true;
  });
};

export const OrderFilters = ({ filters, onChange, orders, shown }) => {
  const partners = Array.from(new Map(orders.filter((o) => o.affiliate?.slug).map((o) => [o.affiliate.slug, o.affiliate.brand_name])).entries());
  const set = (k, v) => onChange({ ...filters, [k]: v });
  const active = Object.values(filters).some(Boolean);
  return (
    <div className="mb-4 flex flex-wrap items-end gap-3 border border-border bg-card p-3" data-testid="order-filters">
      <div className="min-w-[220px] flex-1">
        <label className="mono text-[10px] uppercase tracking-[0.15em] text-muted-foreground">Search</label>
        <Input data-testid="order-filter-q" value={filters.q} onChange={(e) => set("q", e.target.value)} placeholder="Order no, customer, email, tracking…" className="mt-1 rounded-none" />
      </div>
      <div>
        <label className="mono text-[10px] uppercase tracking-[0.15em] text-muted-foreground">Payment</label>
        <select data-testid="order-filter-payment" value={filters.payment} onChange={(e) => set("payment", e.target.value)} className="mt-1 block rounded-none border border-border bg-background p-2 text-sm">
          <option value="">Any</option>
          {["awaiting_payment", "confirming", "paid", "failed", "cancelled"].map((s) => <option key={s} value={s}>{s.replace("_", " ")}</option>)}
        </select>
      </div>
      <div>
        <label className="mono text-[10px] uppercase tracking-[0.15em] text-muted-foreground">Partner</label>
        <select data-testid="order-filter-partner" value={filters.partner} onChange={(e) => set("partner", e.target.value)} className="mt-1 block rounded-none border border-border bg-background p-2 text-sm">
          <option value="">Any</option>
          <option value="__direct">Direct (no partner)</option>
          {partners.map(([slug, name]) => <option key={slug} value={slug}>{name}</option>)}
        </select>
      </div>
      <div>
        <label className="mono text-[10px] uppercase tracking-[0.15em] text-muted-foreground">From</label>
        <Input data-testid="order-filter-from" type="date" value={filters.from} onChange={(e) => set("from", e.target.value)} className="mt-1 rounded-none" />
      </div>
      <div>
        <label className="mono text-[10px] uppercase tracking-[0.15em] text-muted-foreground">To</label>
        <Input data-testid="order-filter-to" type="date" value={filters.to} onChange={(e) => set("to", e.target.value)} className="mt-1 rounded-none" />
      </div>
      <div className="mono self-center text-[11px] text-muted-foreground" data-testid="order-filter-count">{shown} of {orders.length}</div>
      {active && (
        <button data-testid="order-filter-clear" onClick={() => onChange(EMPTY_ORDER_FILTERS)} className="inline-flex items-center gap-1 border border-border px-3 py-2 text-xs hover:border-primary">
          <X className="h-3 w-3" /> Clear
        </button>
      )}
    </div>
  );
};
